import {api} from './context/AuthContext';
export async function loadHymnPdf(signal){
 const r=await api.get('/membership/hymn-pdf',{responseType:'blob',timeout:60000,signal});
 const type=(r.headers?.['content-type']||r.data?.type||'').split(';')[0].trim().toLowerCase();
 if(!(r.data instanceof Blob)||type!=='application/pdf'||r.data.size<5||await r.data.slice(0,5).text()!=='%PDF-')
  throw Error('INVALID_PDF_RESPONSE');
 return r.data;
}
